/**
 * Apre un allegato immagine in modo compatibile con i browser moderni.
 *
 * Problema risolto:
 *   Chrome 72+ e altri browser bloccano `window.open(data:..., '_blank')`
 *   come top-frame navigation → la pagina si apre bianca. Convertiamo i
 *   data:URL in Blob URL (che sono permessi) prima di aprirli.
 *
 * URL http(s):// normali vengono aperti direttamente senza conversione.
 */
export function openAttachment(src) {
  if (!src) return;
  if (typeof src !== 'string') return;

  if (src.startsWith('data:')) {
    try {
      const [header, b64] = src.split(',');
      const mime = (header.match(/data:(.*?);base64/) || [])[1] || 'image/jpeg';
      const binary = atob(b64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      const blob = new Blob([bytes], { type: mime });
      const url = URL.createObjectURL(blob);
      const win = window.open(url, '_blank', 'noopener,noreferrer');
      if (!win) {
        // Popup bloccato → fallback download
        const a = document.createElement('a');
        a.href = url;
        a.download = `allegato_${Date.now()}.${(mime.split('/')[1] || 'jpg').replace('+xml', '')}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      // Libera memoria dopo 60s
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      console.error('Errore apertura allegato:', e);
      alert("Impossibile aprire l'allegato");
    }
  } else {
    window.open(src, '_blank', 'noopener,noreferrer');
  }
}
